module.exports = __webpack_public_path__ + "img/expert2.87bde184.png";